import { useState } from "react";
import DynamicForm from "./DynamicForm";

export default function ParameterForm({ incidentType, answers, onAnswersChange, onNext, onBack }) {
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    incidentType.parameters.forEach((field) => {
      if (field.type === "attachment") return;
      const val = answers[field.id];
      if (val === undefined || val === null || val === "") {
        errs[field.id] = "This field is required.";
      }
    });
    return errs;
  };

  const handleNext = () => {
    const errs = validate();
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }
    setErrors({});
    onNext();
  };

  const handleChange = (id, value) => {
    onAnswersChange({ ...answers, [id]: value });
    if (errors[id]) setErrors((e) => ({ ...e, [id]: undefined }));
  };

  return (
    <div className="form-card">
      <h2 className="card-title">{incidentType.label}</h2>
      <p className="card-subtitle">Step 1 of 2 — Provide the basic details for this incident.</p>

      <div className="form-section">
        <div className="form-section-title">Parameters</div>
        <DynamicForm
          fields={incidentType.parameters}
          answers={answers}
          onAnswerChange={handleChange}
          fileMap={{}}
          onFileChange={() => {}}
          errors={errors}
        />
      </div>

      <div className="btn-row">
        <button className="btn-secondary" onClick={onBack}>Back</button>
        <button className="btn-primary" onClick={handleNext}>Continue</button>
      </div>
    </div>
  );
}
